export default "__VITE_ASSET__M5ewyMGO__"